<template>
	<div class="scrollable only-y">
		<el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
			<div class="page-header card-base card-shadow--medium">
				<h2 class="no-m white-text"><i class="mdi mdi-coin widget-icon accent-text fs-30"></i> {{ $t('menu.biller_switcher') }}</h2>
			</div>
		</el-col>

		<el-card>
			<template>
				Biller Switcher
			</template>
			<!-- <el-alert description="Maintenance to get list service, you can try to add service. Thank you" type="info" :closable="false" title="Information" show-icon></el-alert> -->
		</el-card>
		<el-card class="mt-20 mb-20 card-base" style="border:none; color:white;">
			DAM Corp.
		</el-card>
		<!-- <el-card class="mt-10">
			<el-pagination
				background
				prev-text="Prev"
				next-text="Next"
				layout="prev, pager, next"
				:page-size="10"
				@current-change="paginateHSM"
				:current-page="currentPage"
				:total="parseInt(total)">
			</el-pagination>
		</el-card> -->
	</div>
</template>

<script>
import api from '@/networkClient'
import config from '@/config'
// import moment from 'moment-timezone'
const moment = require('moment')

export default {
	name: 'biller_switcher',
	data () {
		return {
			loadingTemplate: true,
			currentPage: 1,
			total:'',
			dialogFormVisible:false,
			loadingBtn:false,
			formLabelWidth: '200px',
			paramCredentials:{
				user: '',
				startDate: '',
				endDate: ''
			}
		}
	},
	methods: {
		async getTransaction(){
			console.log("Get biller transaction")
			this.loadingTemplate = true
			var self = this
			await api({
				url:config.baseApi+'biller/get_transaction',
				method:'get'
			}).then(response => {
				console.log(response.data)
				if(response.data.ec != 200){
					this.$swal(this.$t('error'), "Tenang, ini bukan kesalahan Anda", "error")
				} else {
					console.log(response.data)
				}
				this.loadingTemplate = false
			}).catch(error => {
				this.loadingTemplate = false
			})
		},
		async paginateHSM(page){
			this.currentPage = page
			await this.getAllHSM(this.currentPage)
		},
		clear(){
			this.service.name = ""
			this.service.port = ""
			this.service.password = ""
			this.service.ip = ""
		}
	},
	async mounted(){
		await this.getTransaction()
	}
}
</script>

<style lang="scss" scoped>
.float-image {
	float:right;
	z-index: 1;
	bottom: 10px;
	left: 10px;
}
.gradient-api {
	background:#249393;
	background: linear-gradient(260deg, #4ac5c5, #249393);
}
.white-text {
	color: white;
}
.page-header {
	margin-bottom: 30px;
}
</style>
